import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ServicesSection = () => {
  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/service-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/service`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);
  return (
    <section className="working-section centred pb_120 modern-home-section" id="services-sec">
      <div className="pattern-layer" style={{ backgroundImage: "url(assets/images/shape/shape-4.png)" }} />
      <div className="auto-container">
        <div className="modern-section-heading">
          <span className="sub-title">{service[0]?.serviceHeading || "Our Services"}</span>
          <h2>{service[0]?.servicesubHeading || "Practical AI systems that save time and win more leads"}</h2>
          <p>
            We design automation around the real questions, bookings, and follow-ups your business handles every day.
          </p>
        </div>

        <div className="inner-container">
          <div className="row clearfix">
            {items.map((item) => (
              <div className="col-lg-4 col-md-6 col-sm-12 working-block" key={item._id}>
                <div className="working-block-one modern-service-card">
                  <div className="inner-box">
                    <div className="upper-box">
                      <div className="modern-service-icon-wrap">
                        <img src={item.serviceIcon} alt={item.serviceTitle} className="modern-service-icon" />
                      </div>
                    </div>
                    <div className="lower-content">
                      <h3>{item.serviceTitle}</h3>
                      <p>{item.serviceDetails}</p>
                      <Link to="/contact-us" className="modern-inline-link">
                        Discuss this solution
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
